<template>
  <div class="table-wrapper loader-container current-verions">
    <vue-good-table
      :columns="columns"
      :rows="[currentVersions]"
    ></vue-good-table>
  </div>
</template>
<script>
import { VueGoodTable } from "vue-good-table";
import { mapState } from "vuex";

export default {
  components: { VueGoodTable },
  computed: {
    ...mapState(["currentVersions"])
  },
  data() {
    return {
      columns: [
        {
          label: "Alpha",
          field: "alphaVersion",
          sortable: false
        },
        {
          label: "Beta",
          field: "betaVersion",
          sortable: false
        },
        {
          label: "Release",
          field: "releaseVersion",
          sortable: false
        },
        {
          label: "Stable",
          field: "stableVersion",
          sortable: false
        }
      ]
    };
  }
};
</script>
